module.exports = __webpack_public_path__ + "static/media/moon.0e2bb8d6.svg";